import Icon from '../components/Icon.vue'

Icon.register({"inbox":{"width":576,"height":512,"paths":[{"d":"M567.9 243.9L462.3 85.4A48-48 0 0 1 422.3 64H153.7A48-48 0 0 1 113.8 85.4L8.1 243.9A48-48 0 0 1 0 270.5V400C0 426.5 21.5 448 48 448H528C554.5 448 576 426.5 576 400V270.5A48-48 0 0 1 567.9 243.9zM162.3 128H413.7L499.1 256H376L344 320H232L200 256H76.9L162.3 128z"}]}})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/inbox.js
// module id = 79tH
// module chunks = 0